export const MANNY = {
  CHAT: {
    USER_MESSAGE: {
      CONTAINER: 'manny-chat-message-container',
      TEXT: 'manny-chat-message-text',
      COPY_BUTTON: 'manny-chat-message-copy-button',
      EDIT_BUTTON: 'manny-chat-message-edit-button'
    },
    ASSISTANT_MESSAGE: {
      CONTAINER: 'manny-chat-assistant-message-container',
      TEXT: 'manny-chat-assistant-message-text',
      COPY_BUTTON: 'manny-chat-assistant-message-copy-button',
      THUMB_UP_BUTTON: 'manny-chat-assistant-message-thumb-up-button',
      THUMB_DOWN_BUTTON: 'manny-chat-assistant-message-thumb-down-button',
      RELOAD_BUTTON: 'manny-chat-assistant-message-reload-button'
    },
    FEEDBACK_DIALOG: {
      CONTAINER: 'manny-chat-feedback-dialog-container',
      CLOSE_BUTTON: 'manny-chat-feedback-dialog-close-button',
      TEXTAREA: 'manny-chat-feedback-dialog-textarea',
      CANCEL_BUTTON: 'manny-chat-feedback-dialog-cancel-button',
      SUBMIT_BUTTON: 'manny-chat-feedback-dialog-submit-button'
    },
    FILTER_ACTION: {
      APPLY_BUTTON: 'manny-chat-filter-action-apply-button',
      CANCEL_BUTTON: 'manny-chat-filter-action-cancel-button',
      CONFIRM_BUTTON: 'manny-chat-filter-action-confirm-button',
      STOP_BUTTON: 'manny-chat-filter-action-stop-button'
    },
    SUGGESTED_ACTIONS: {
      COPY_PROMPT_BUTTON: 'manny-chat-suggested-actions-copy-prompt-button',
      APPLY_FILTER_BUTTON: 'manny-chat-suggested-actions-apply-filter-button'
    }
  }
} as const;
